import React from "react";
import ActionPopover from "Components/templates/Tenants/ActionPopover";
import BreadCrumbs from "Components/molecules/Breadcrumbs";
import FormControls from './FormControls';
import SiteNavigation from "Components/molecules/SiteNavigation";
import useTenants from "Hooks/useTenants";
import {Box, Divider, Grid, Text} from "theme-ui";
import {useTable} from 'react-table';
import Loader from "Components/molecules/Loader";

function Tenants() {
    const tenants = useTenants();
    const columns = React.useMemo(() => [
        {
            Header: 'Name',
            accessor: 'col1'
        },
        {
            Header: 'Environment',
            accessor: 'col2'
        },
        {
            Header: 'Action',
            accessor: 'col3'
        }
    ], [])
    const data =
         tenants?.data?.sort((a,b) => a.name-b.name).map(tenant => ({
            col1: tenant.name,
             col2: tenant.branch,
            col3: <ActionPopover tenant={tenant}/>
        })) || [];


    const {
        getTableProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data })

    if(tenants.isLoading) return <Loader isActive={true}/>

    return (
        <Grid variant="layout" bg="muted" height="100%">
            <Grid variant="layout.header" bg="background" gap={0}>
                <SiteNavigation/>
                <Divider variant="layout.header.divider" color="lightgray"/>
                <BreadCrumbs/>
                <FormControls/>
            </Grid>
            <Box variant="layout.body" bg="background" py='4' px="4">
                <Box variant="tenant-table" as="table" {...getTableProps()} >
                    <Box as="col" width="90%" variant="tenant-table.name"/>
                    <Box as="col" width="20%" variant="tenant-table.actions"/>
                    {headerGroups.map((headerGroup, i) => (
                        <Box as="tr" height="54px" key={`header-${i}`} {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, i) => (
                                <Box
                                    as="th"
                                    key={`column-${i}`}
                                    alignItems="center"
                                    px={3}
                                    textAlign="left"
                                    {...column.getHeaderProps()}
                                >
                                    {column.render('Header')}
                                </Box>
                            ))}
                        </Box>
                    ))}
                    {rows.map((row, i) => {
                        prepareRow(row)
                        return (
                            <tr key={`row-${i}`}{...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    return (
                                        <Box
                                            as="td"
                                            key={`cell-${i}`}
                                            padding={3}
                                            {...cell.getCellProps()}
                                        >
                                            {cell.render('Cell')}
                                        </Box>
                                    );

                                })}
                            </tr>
                        )
                    })}
                </Box>
            </Box>
        </Grid>
    );
}

export default Tenants;